<template>
  <aside class="sidebar-container menu has-text-centered">
    <div class="float-bar columns is-centered">
      <div class="column is-11">
        <!-- <h1 class="course-name title has-text-left is-4">{{ course.name }}</h1> -->

        <h1 class="course-name title has-text-centered is-4">GenEx</h1>

        <!-- <button class="button download-all" @click="downloadFiles">{{buttonText}}</button> -->
        <div class="buttons box">
          <button
            class="button is-fullwidth is-outlined top-level-item-title"
            @click="goToLastLesson($store.state.lastLesson.lastViewedLesson.last_viewed_course_id,$store.state.lastLesson.lastViewedLesson.last_viewed_module_id,$store.state.lastLesson.lastViewedLesson.last_viewed_lesson_id)"
            v-html="'Back to Course'"
          ></button>
          <button
            class="button is-fullwidth is-outlined top-level-item-title"
            @click="toggleActiveItem('overview')"
            v-html="'Unit Overview'"
            :class="{'is-active':isItemActive('overview')}"
          ></button>
          <div class="sub-level-container" v-show="isItemActive('overview')">
            <div v-for="(unit, i) in this.$store.state.sidebar.units" :key="i">
              <button
                class="button is-fullwidth sub-level-item is-outlined"
                @click="gotoCourse(unit.id)"
              >{{unit.name}}</button>
            </div>
          </div>
          <router-link
            class="button is-fullwidth is-outlined top-level-item-title"
            to="/calendar"
          >Calendar</router-link>
          <!-- <router-link
            class="button is-fullwidth is-outlined top-level-item-title"
            to="/chat"
          >Chat Room</router-link>-->
          <button
            class="button is-fullwidth is-outlined top-level-item-title"
            @click="toggleActiveItem('e-portfolio')"
            :class="{'is-active':isItemActive('e-portfolio')}"
          >ePortfolio</button>
          <div class="sub-level-container" v-show="isItemActive('e-portfolio')">
            <router-link
              class="button is-fullwidth sub-level-item is-outlined"
              to="/my-journal"
            >My Journal</router-link>
            <router-link
              class="button is-fullwidth sub-level-item is-outlined"
              to="/my-tasks"
            >My Tasks</router-link>
            <router-link
              class="button is-fullwidth sub-level-item is-outlined"
              to="/my-resources"
            >My Resources</router-link>
          </div>
          <!-- <router-link
            class="button is-fullwidth is-outlined top-level-item-title"
            to="/resources"
          >Resources</router-link>-->

          <button
            :class="{'is-loading':loadingForum}"
            v-if="$store.state.auth.user.groups.length<2"
            @click="goToForum($store.state.auth.user.groups[0].id)"
            class="button is-fullwidth is-outlined top-level-item-title"
          >Forum</button>

          <button
            v-if="$store.state.auth.user.groups.length>1"
            class="button is-fullwidth is-outlined top-level-item-title"
            @click="toggleActiveItem('forums')"
            :class="{'is-active':isItemActive('forums'), 'is-loading':loadingForum}"
          >Forums</button>
          <div class="sub-level-container" v-show="isItemActive('forums')">
            <button
              v-for="(group,index) in $store.state.auth.user.groups"
              :key="index"
              @click="goToForum(group.id)"
              class="button is-fullwidth sub-level-item is-outlined"
            >{{group.name}}</button>
          </div>
          <!-- <router-link
            class="button is-fullwidth is-outlined top-level-item-title"
            to="/chat"
          >Chat Room</router-link>-->
        </div>
      </div>
    </div>
  </aside>
</template>

<script>
import BaseHelper from "@/helpers/BaseHelper";
import { CourseClient } from "../../clients/CourseClient";
import { ForumClient } from "../../clients/ForumClient";

export default {
  name: "Sidebar",
  data() {
    return {
      loadingForum: false,
      activeItems: [],
      buttonText: "Download Resource Pack",
      assetsPath: null,
      searchTerm: ""
    };
  },
  mixins: [BaseHelper],
  methods: {
    goToForum(group_id) {
      this.loadingForum = true;
      ForumClient.getForums(group_id)
        .then(result => {
          this.loadingForum = false;
          if (result.data.forums.length == 0) {
            alert("This group has no forum");
          }
          this.$router.push(`/forum/${result.data.forums[0].id}`);
        })
        .catch(err => {});
    },
    goToLastLesson(courseId, moduleId, lessonId) {
      this.gotoLesson(courseId, moduleId, lessonId);
    },
    downloadFiles() {
      if (this.assetsPath !== null) {
        return (window.location = this.assetsPath);
      }

      this.$store.dispatch("loader/show", "Packing resources....");
      CourseClient.downloadFiles()
        .then(response => {
          this.$store.dispatch("loader/hide");
          let fileLocation = response.data.file;
          if (fileLocation !== null) {
            this.assetsPath = fileLocation;
            this.buttonText = "Click to download assets now.";
          }
        })
        .catch(() => {
          this.$store.dispatch("loader/hide");
        });
    },
    toggleActiveItem(title) {
      if (this.activeItems.includes(title)) {
        this.activeItems.splice(this.activeItems.indexOf(title));
      } else {
        this.activeItems.push(title);
      }
    },
    isItemActive(title) {
      if (this.activeItems.includes(title)) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted() {
    this.$store.dispatch("GET_UNITS");
    this.$store.dispatch("lastLesson/getLastLesson");
  }
};
</script>




